import React, { Component } from "react";
import KheshtiTabTileItem from "./items/tile";
import KheshtiTabBackgroundItem from "./items/kheshtiBackground";

export default class KheshtiTabItems extends Component {
  render() {
    const { stepOnboarding } = this.props;

    return (
      <ul
        className="ul-background-select"
        style={{ zIndex: stepOnboarding === 3 ? 1 : 0 }}
      >
        <KheshtiTabTileItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
          themeDirection={this.props.themeDirection}
        />
        <KheshtiTabBackgroundItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
          themeDirection={this.props.themeDirection}
        />
      </ul>
    );
  }
}
